import { Box, Button, Card, CardContent, Modal, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useTheme } from "@mui/material/styles";
import Pagos from './Pagos';
import DataCuentaDetalle from './DataCuentaDetalle';

const DataCuenta = ({dataCuentas,identificador, id_linea_negocio}) => {
  const [open, setOpen] = useState(false);
  const [openPagos, setOpenPagos] = useState(false);
  const [cuenta_id, setCuentaID] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const theme = useTheme();
  const keysToHide = ["id_cuenta", "id_cliente", "id_cartera_id", "id_detalle_cuenta", "estado", "llave", "detalle"];
  const handleOpen = (detalleCuenta) => {
    setCuentaID(detalleCuenta.id);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpenPagos = (detalleCuenta) => {
    setCuentaID(detalleCuenta.id);
    setOpenPagos(true);
  };
  const handleClosePagos = () => {
    setOpenPagos(false);
  };

  useEffect(() => {
    if (dataCuentas && dataCuentas.length > 0) {
      setIsLoading(false);
    }
  }, [dataCuentas]);
  
  if (isLoading) {
    return (
      <div>
        <Modal
          open={isLoading}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 4,
            }}
          >
            <Typography id="modal-title">Cargandoss datos...</Typography>
          </Box>
        </Modal>
      </div>
    );
  }
  return (
    <Card elevation={3}>
      <Box position="relative">

        <Box position="absolute" top={0} left={0} bgcolor="green" color="white" py={0.5} px={2}>
          <Typography variant="button">Detalle Cliente</Typography>
        </Box>
        <CardContent>
        <TableContainer component={Paper} sx={{ maxWidth: "100%", margin: "auto" }} >
          <Table>
            <TableHead>
              <TableRow>
                {Object.keys(dataCuentas[0])
                  .filter(key => !keysToHide.includes(key))
                  .map(key => (
                    <TableCell key={key} 
                        style={{backgroundColor: theme.palette.primary.main, color: theme.palette.common.white}}>
                        {key.split('_').join(' ').toUpperCase()}
                        </TableCell>

                    ))}
                    {dataCuentas.some(item => item.pagos) && (
                          <TableCell style={{backgroundColor: theme.palette.primary.main, color: theme.palette.common.white}}>
                              Acción
                          </TableCell>
                      )}
                            {dataCuentas.some(item => item.detalle) && (
                          <TableCell style={{backgroundColor: theme.palette.primary.main, color: theme.palette.common.white}}>
                              Detalle
                          </TableCell>
                      )}

              </TableRow>
            </TableHead>
            <TableBody>
              {dataCuentas.map((item, index) => (
                <TableRow
                  key={index}
                  hover
                  sx={{
                    "&:hover": {
                      backgroundColor: theme.palette.action.hover,
                    },
                    "& td": {
                      border: "1px solid rgba(224, 224, 224, 1)",
                      padding: theme.spacing(1),
                    },
                  }}
                >
                {Object.entries(item)
                .filter(([key]) => !keysToHide.includes(key))
                .map(([key, value], valueIndex) => (
                    <TableCell key={valueIndex}>{value}</TableCell>
                ))}

            {dataCuentas.some(item => item.pagos) ? (
                item.pagos ? (
                    <TableCell>
                        <Button
                            onClick={() => handleOpenPagos(item)}
                            // ... el resto del código
                        >
                            Ver Pagos
                        </Button>
                    </TableCell>
                ) : (
                    <TableCell></TableCell>
                )
            ) : null}

            {dataCuentas.some(item => item.detalle) ? (
                item.detalle ? (
                    <TableCell>
                        <Button
                            onClick={() => handleOpen(item)}
                        >
                            Ver detalle
                        </Button>
                    </TableCell>
                ) : (
                    <TableCell></TableCell>
                )
            ) : null}
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <DataCuentaDetalle open={open} handleClose={handleClose}   identificador={identificador}
              id_linea_negocio={id_linea_negocio}
              cuenta_id={cuenta_id} />
            <Pagos
              open={openPagos}
              handleClose={handleClosePagos}
              identificador={identificador}
              id_linea_negocio={id_linea_negocio}
              cuenta_cliente={cuenta_id}
            />
        </TableContainer>
        </CardContent>
      </Box>

      </Card>
  )
}

export default DataCuenta